import React, {Fragment, FunctionComponent} from 'react'
import {ExclamationCircleIcon} from "@heroicons/react/solid";
import {CaretDownIcon} from "@App/Components/common/Icons";

export type PhoneInput = {
    country: string,
    number: string | null
}

type PhoneInputProps = {
    id?: string
    type?: string
    name?: string
    placeholder?: string
    value?: PhoneInput
    className?: string
    required?: boolean
    onChange?: (phone: PhoneInput) => void
    validationMessage?: string
}


export const PhoneInput: FunctionComponent<PhoneInputProps> = (props: PhoneInputProps) => {

    const onChange = async (event) => {
        props.onChange({
            country: event.target.name === 'country'
                ? event.target.value
                : props.value.country,
            number: event.target.name === props.name
                ? event.target.value.replace(/[^0-9-./]/g, "")
                : props.value.number,
        })
    }

    return (
        <Fragment>
            <div className="mt-1 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-1 flex items-center">
                    <label htmlFor="country" className="sr-only">
                        Land
                    </label>
                    <select
                        id="country"
                        name="country"
                        autoComplete="country"
                        onChange={onChange}
                        value={props.value.country}
                        className=" appearance-none
                            focus:ring-indigo-500 focus:border-indigo-500
                            py-0 pl-3
                            border-transparent
                            bg-transparent text-gray-500 sm:text-sm rounded-md cursor-pointer">
                        <option value={"+49"}>DE (+49)</option>
                        <option value="+093">AF (+093)</option>
                        <option value="+020">EG (+020)</option>
                        <option value="+355">AL (+355)</option>
                        <option value="+213">DZ (+213)</option>
                        <option value="+376">AD (+376)</option>
                        <option value="+244">AO (+244)</option>
                        <option value="+001">AI (+001)</option>
                        <option value="+672">AQ (+672)</option>
                        <option value="+001">AG (+001)</option>
                        <option value="+240">GQ (+240)</option>
                        <option value="+054">AR (+054)</option>
                        <option value="+374">AM (+374)</option>
                        <option value="+297">AW (+297)</option>
                        <option value="+251">ET (+251)</option>
                        <option value="+061">AU (+061)</option>
                        <option value="+001">BS (+001)</option>
                        <option value="+973">BH (+973)</option>
                        <option value="+880">BD (+880)</option>
                        <option value="+001">BB (+001)</option>
                        <option value="+032">BE (+032)</option>
                        <option value="+501">BZ (+501)</option>
                        <option value="+229">BJ (+229)</option>
                        <option value="+001">BM (+001)</option>
                        <option value="+975">BT (+975)</option>
                        <option value="+095">MM (+095)</option>
                        <option value="+591">BO (+591)</option>
                        <option value="+387">BA (+387)</option>
                        <option value="+267">BW (+267)</option>
                        <option value="+055">BR (+055)</option>
                        <option value="+246">IO (+246)</option>
                        <option value="+673">BN (+673)</option>
                        <option value="+359">BG (+359)</option>
                        <option value="+226">BF (+226)</option>
                        <option value="+257">BI (+257)</option>
                        <option value="+086">CN (+086)</option>
                        <option value="+618">CX (+618)</option>
                        <option value="+682">CK (+682)</option>
                        <option value="+506">CR (+506)</option>
                        <option value="+045">DK (+045)</option>
                        <option value="+049">DE (+049)</option>
                        <option value="+253">DJ (+253)</option>
                        <option value="+001">DM (+001)</option>
                        <option value="+001">DO (+001)</option>
                        <option value="+593">EC (+593)</option>
                        <option value="+503">SV (+503)</option>
                        <option value="+225">CI (+225)</option>
                        <option value="+291">ER (+291)</option>
                        <option value="+372">EE (+372)</option>
                        <option value="+500">FK (+500)</option>
                        <option value="+298">FO (+298)</option>
                        <option value="+679">FJ (+679)</option>
                        <option value="+358">FI (+358)</option>
                        <option value="+033">FR (+033)</option>
                        <option value="+594">GF (+594)</option>
                        <option value="+689">PF (+689)</option>
                        <option value="+596">TF (+596)</option>
                        <option value="+241">GA (+241)</option>
                        <option value="+220">GM (+220)</option>
                        <option value="+995">GE (+995)</option>
                        <option value="+233">GH (+233)</option>
                        <option value="+350">GI (+350)</option>
                        <option value="+001">GD (+001)</option>
                        <option value="+030">GR (+030)</option>
                        <option value="+299">GL (+299)</option>
                        <option value="+044">UK (+044)</option>
                        <option value="+044">GB (+044)</option>
                        <option value="+590">GP (+590)</option>
                        <option value="+001">GU (+001)</option>
                        <option value="+502">GT (+502)</option>
                        <option value="+224">GN (+224)</option>
                        <option value="+245">GW (+245)</option>
                        <option value="+592">GY (+592)</option>
                        <option value="+509">HT (+509)</option>
                        <option value="+061">HM (+061)</option>
                        <option value="+504">HN (+504)</option>
                        <option value="+852">HK (+852)</option>
                        <option value="+091">IN (+091)</option>
                        <option value="+062">ID (+062)</option>
                        <option value="+964">IQ (+964)</option>
                        <option value="+098">IR (+098)</option>
                        <option value="+353">IE (+353)</option>
                        <option value="+354">IS (+354)</option>
                        <option value="+972">IL (+972)</option>
                        <option value="+039">IT (+039)</option>
                        <option value="+001">JM (+001)</option>
                        <option value="+081">JP (+081)</option>
                        <option value="+967">YE (+967)</option>
                        <option value="+962">JO (+962)</option>
                        <option value="+381">YU (+381)</option>
                        <option value="+001">KY (+001)</option>
                        <option value="+855">KH (+855)</option>
                        <option value="+237">CM (+237)</option>
                        <option value="+001">CA (+001)</option>
                        <option value="+238">CV (+238)</option>
                        <option value="+007">KZ (+007)</option>
                        <option value="+254">KE (+254)</option>
                        <option value="+996">KG (+996)</option>
                        <option value="+686">KI (+686)</option>
                        <option value="+061">CC (+061)</option>
                        <option value="+057">CO (+057)</option>
                        <option value="+269">KM (+269)</option>
                        <option value="+242">CG (+242)</option>
                        <option value="+243">CD (+243)</option>
                        <option value="+385">HR (+385)</option>
                        <option value="+053">CU (+053)</option>
                        <option value="+965">KW (+965)</option>
                        <option value="+856">LA (+856)</option>
                        <option value="+266">LS (+266)</option>
                        <option value="+371">LV (+371)</option>
                        <option value="+961">LB (+961)</option>
                        <option value="+231">LR (+231)</option>
                        <option value="+218">LY (+218)</option>
                        <option value="+423">LI (+423)</option>
                        <option value="+356">MT (+356)</option>
                        <option value="+001">MP (+001)</option>
                        <option value="+212">MA (+212)</option>
                        <option value="+692">MH (+692)</option>
                        <option value="+596">MQ (+596)</option>
                        <option value="+222">MR (+222)</option>
                        <option value="+230">MU (+230)</option>
                        <option value="+269">YT (+269)</option>
                        <option value="+389">MK (+389)</option>
                        <option value="+052">MX (+052)</option>
                        <option value="+691">FM (+691)</option>
                        <option value="+258">MZ (+258)</option>
                        <option value="+373">MD (+373)</option>
                        <option value="+377">MC (+377)</option>
                        <option value="+976">MN (+976)</option>
                        <option value="+001">MS (+001)</option>
                        <option value="+264">NA (+264)</option>
                        <option value="+674">NR (+674)</option>
                        <option value="+977">NP (+977)</option>
                        <option value="+687">NC (+687)</option>
                        <option value="+064">NZ (+064)</option>
                        <option value="+505">NI (+505)</option>
                        <option value="+031">NL (+031)</option>
                        <option value="+599">AN (+599)</option>
                        <option value="+227">NE (+227)</option>
                        <option value="+234">NG (+234)</option>
                        <option value="+683">NU (+683)</option>
                        <option value="+672">NF (+672)</option>
                        <option value="+047">NO (+047)</option>
                        <option value="+968">OM (+968)</option>
                        <option value="+043">AT (+043)</option>
                        <option value="+092">PK (+092)</option>
                        <option value="+970">PS (+970)</option>
                        <option value="+680">PW (+680)</option>
                        <option value="+507">PA (+507)</option>
                        <option value="+675">PG (+675)</option>
                        <option value="+595">PY (+595)</option>
                        <option value="+051">PE (+051)</option>
                        <option value="+063">PH (+063)</option>
                        <option value="+872">PN (+872)</option>
                        <option value="+048">PL (+048)</option>
                        <option value="+351">PT (+351)</option>
                        <option value="+001">PR (+001)</option>
                        <option value="+974">QA (+974)</option>
                        <option value="+262">RE (+262)</option>
                        <option value="+250">RW (+250)</option>
                        <option value="+040">RO (+040)</option>
                        <option value="+007">RU (+007)</option>
                        <option value="+001">LC (+001)</option>
                        <option value="+260">ZM (+260)</option>
                        <option value="+684">AS (+684)</option>
                        <option value="+684">WS (+684)</option>
                        <option value="+378">SM (+378)</option>
                        <option value="+239">ST (+239)</option>
                        <option value="+966">SA (+966)</option>
                        <option value="+046">SE (+046)</option>
                        <option value="+268">CH (+268)</option>
                        <option value="+221">SN (+221)</option>
                        <option value="+248">SC (+248)</option>
                        <option value="+232">SL (+232)</option>
                        <option value="+065">SG (+065)</option>
                        <option value="+421">SK (+421)</option>
                        <option value="+386">SI (+386)</option>
                        <option value="+677">SB (+677)</option>
                        <option value="+252">SO (+252)</option>
                        <option value="+995">GS (+995)</option>
                        <option value="+034">ES (+034)</option>
                        <option value="+094">LK (+094)</option>
                        <option value="+290">SH (+290)</option>
                        <option value="+001">KN (+001)</option>
                        <option value="+508">PM (+508)</option>
                        <option value="+001">VC (+001)</option>
                        <option value="+027">ZA (+027)</option>
                        <option value="+249">SD (+249)</option>
                        <option value="+597">SR (+597)</option>
                        <option value="+047">SJ (+047)</option>
                        <option value="+268">SZ (+268)</option>
                        <option value="+963">SY (+963)</option>
                        <option value="+992">TJ (+992)</option>
                        <option value="+886">TW (+886)</option>
                        <option value="+255">TZ (+255)</option>
                        <option value="+066">TH (+066)</option>
                        <option value="+670">TP (+670)</option>
                        <option value="+228">TG (+228)</option>
                        <option value="+690">TK (+690)</option>
                        <option value="+676">TO (+676)</option>
                        <option value="+001">TT (+001)</option>
                        <option value="+235">TD (+235)</option>
                        <option value="+420">CZ (+420)</option>
                        <option value="+216">TN (+216)</option>
                        <option value="+090">TR (+090)</option>
                        <option value="+993">TM (+993)</option>
                        <option value="+001">TC (+001)</option>
                        <option value="+688">TV (+688)</option>
                        <option value="+256">UG (+256)</option>
                        <option value="+380">UA (+380)</option>
                        <option value="+036">HU (+036)</option>
                        <option value="+598">UY (+598)</option>
                        <option value="+998">UZ (+998)</option>
                        <option value="+678">VU (+678)</option>
                        <option value="+039">VA (+039)</option>
                        <option value="+058">VE (+058)</option>
                        <option value="+971">AE (+971)</option>
                        <option value="+001">US (+001)</option>
                        <option value="+084">VN (+084)</option>
                        <option value="+001">VG (+001)</option>
                        <option value="+340">VI (+340)</option>
                        <option value="+681">WF (+681)</option>
                        <option value="+375">BY (+375)</option>
                        <option value="+212">EH (+212)</option>
                        <option value="+236">CF (+236)</option>
                        <option value="+263">ZW (+263)</option>
                        <option value="+357">CY (+357)</option>
                        <option value="+082">KS (+082)</option>
                        <option value="+370">LT (+370)</option>
                        <option value="+352">LU (+352)</option>
                        <option value="+853">MO (+853)</option>
                        <option value="+261">MG (+261)</option>
                        <option value="+265">MW (+265)</option>
                        <option value="+060">MY (+060)</option>
                        <option value="+960">MV (+960)</option>
                        <option value="+223">ML (+223)</option>
                        <option value="+850">KN (+850)</option>
                    </select>
                    <CaretDownIcon className={'w-3 h-w'} color={'neutral-500'} />
                </div>
                <input
                    className={`
                    border border-neutral-500
                    rounded
                    shadow
                    ${props.validationMessage && ('border-error-300 text-error-900 placeholder-error-300 focus:outline-none focus:ring-error-500 focus:border-error-500 ')}
                    py-2 pr-3 pl-32 my-2 ${props.className}`}
                    id={props.id}
                    type={props.type || 'text'}
                    name={props.name}
                    placeholder={props.placeholder}
                    required={props.required}
                    value={props.value.number ?? ''}
                    onChange={onChange}/>
                {props.validationMessage && (
                    <div
                        className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                        <ExclamationCircleIcon className="h-5 w-5 text-error-500" aria-hidden="true"/>
                    </div>
                )}
            </div>
            {props.validationMessage && (
                <p className="mt-1 mb-4 text-sm text-error-600" id={`${props.id}-error`}>
                    {props.validationMessage}
                </p>
            )}
        </Fragment>
    )
}
